module.exports = __webpack_public_path__ + "img/anthropologie.b72db9d.svg";